import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './admanage.routes';
import addHtml from './modal/add.html';
import _ from 'lodash';


export class AdManageController {
    $http;
    socket;
    awesomeThings = [];
    adManages = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;

        this.languageTypes = [
            { value: 'pt', name: '葡语' },
            { value: 'en', name: '英语' },
            { value: 'es', name: '西语' }
        ]

    }

    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/ad_manage/?all=true', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.admanages = response.data.data;
                        this.socket.syncUpdates('admanages', this.admanages);
                    }

                });


            this.getTypeName = function (value) {
                var ret = _.find(this.languageTypes, { value: value });
                if (ret) {
                    return ret.name;
                }
                return '';
            }

        } else {
            this.$location.path('main')
        }
    }


    search() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/ad_manage/?all=true', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': this.currentPage - 1,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.admanages = response.data.data;

                        this.socket.syncUpdates('admanages', this.admanages);
                    }
                });
        } else {
            this.$location.path('main')
        }


    }



    addShareImg() {
        const admanages = this.admanages;

        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance, $cookies, FileUploader) {
                $scope.vm = {};

                $scope.languageTypes = [
                    { value: 'pt', name: '葡语' },
                    { value: 'en', name: '英语' },
                    { value: 'es', name: '西语' }
                ]
                $scope.isloadcover = false;
                $scope.isloadcoversmall = false;


                let uploader1 = $scope.uploaderImage = new FileUploader({
                    url: '/api/ad_manage/9528/',
                    method: 'POST',
                    autoUpload: true,
                });


                let uploader2 = $scope.uploaderImageSmall = new FileUploader({
                    url: '/api/ad_manage/9529/',
                    method: 'POST',
                    autoUpload: true,
                });




                uploader1.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcover = true;
                            $scope.isloadcoverError = false;
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadcoverError = true;

                            return false;
                        }

                    }
                });

                uploader2.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcoversmall = true;
                            $scope.isloadcoversmallError = false;
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadcoversmallError = true;

                            return false;
                        }

                    }
                });






                uploader1.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcover = false;
                        console.log(response.data);
                        $scope.vm.img_url = response.data.img_url;
                    }
                };


                uploader2.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcoversmall = false;
                        console.log(response.data);
                        $scope.vm.banner_url = response.data.banner_url;
                    }
                };


                $scope.clearItems1 = function () {
                    uploader1.clearQueue();
                }

                $scope.clearItems2 = function () {
                    uploader2.clearQueue();
                }





                $scope.save = function (myForm) {

                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        console.log($scope.vm);
                        $http.post('/api/ad_manage/', $scope.vm).then((response) => {
                            console.log(response.data.data);
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (data) {
                if (data) {
                    admanages.push(data);
                }
            }, function () {
            });
    }


    editShareImg(item, index) {
        const admanages = this.admanages;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance, $cookies, FileUploader) {
                $scope.vm = angular.copy(item);
                $scope.languageTypes = [
                    { value: 'pt', name: '葡语' },
                    { value: 'en', name: '英语' },
                    { value: 'es', name: '西语' }
                ]
                // $scope.isload = false;
                $scope.isloadcover = false;
                $scope.isloadcoversmall = false;


                let uploader1 = $scope.uploaderImage = new FileUploader({
                    url: '/api/ad_manage/9528/',
                    method: 'POST',
                    autoUpload: true,
                });



                uploader1.filters.push({
                    name: 'Filter',
                    fn: function (item, options) {
                        if (item.type.indexOf('image') !== -1) {
                            $scope.isloadcover = true;
                            $scope.isloadcoverError = false;
                            return true;
                        } else {
                            console.log('请选择正确的文件格式!', 'ERROR!');
                            $scope.isloadcoverError = true;

                            return false;
                        }

                    }
                });




                uploader1.onSuccessItem = function (fileItem, response, status, headers) {
                    if (status === 200) {
                        console.log('上传成功!', 'SUCCESS!');
                        $scope.isloadcover = false;
                        $scope.vm.img_url = response.data.img_url;

                    }
                };

                $scope.clearItems1 = function () {
                    uploader1.clearQueue();
                }


                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        console.log($scope.vm);
                        $http.put('/api/ad_manage/' + item._id + '/', $scope.vm).then((response) => {
                            console.log(response);
                            $uibModalInstance.close(response.data.data);
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
            .result.then(function (ret) {
                if (ret) {
                    admanages[index] = ret;
                }
            }, function () {
            });
    }



    deleteShareImg(item, index) {
        this.$http.delete('/api/ad_manage/' + item._id + '/').then(response => {
            if (response.status === 200) {
                this.admanages.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }
}

export default angular.module('tttApp.admanage', [uiRouter])
    .config(routing)
    .component('admanage', {
        template: require('./admanage.html'),
        controller: AdManageController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/admanage/admanage.component.js